{
  "name": "demf-kpim-measures-list",
  "version": "3.3.1",
  "private": false,
  "type": "module",
  "engines": {
    "node": ">=22.0.0 <23 || >=24.8.0 <25"
  },
  "scripts": {
    "predev": "node ./scripts/generate-vuetify-locales.mjs",
    "dev": "concurrently \"vite build --watch --mode development\" \"vite preview --port 9907\"",
    "prebuild": "node ./scripts/generate-vuetify-locales.mjs",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint . --fix",
    "format": "prettier --write src/"
  },
  "dependencies": {
    "@mdi/font": "^7.4.47",
    "axios": "^1.20.0",
    "pinia": "^4.0.3",
    "single-spa-vue": "^3.0.1",
    "vue": "^3.5.42",
    "vue-i18n": "^11.4.10",
    "vue-router": "^5.3.1",
    "vuetify": "^3.13.4"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vue/eslint-config-prettier": "^10.2.0",
    "concurrently": "^10.0.5",
    "eslint": "^10.10.0",
    "eslint-plugin-vue": "^10.11.0",
    "globals": "^17.12.0",
    "prettier": "^3.9.6",
    "vite": "^8.2.2",
    "vite-plugin-css-injected-by-js": "^5.0.2",
    "vite-plugin-vue-devtools": "^8.2.1"
  }
}
